import {Inject, Injectable} from '@angular/core';
import {combineLatest, Observable, ReplaySubject} from 'rxjs';
import {filter, map, shareReplay} from 'rxjs/operators';
import {CategoryMenu, CategoryMenuItem} from '../../model/category-menu';
import {Product} from '../../model/product';
import {CATEGORIES_MENU} from '../categories-menu/main-menu.providers';

@Injectable()
export class ProductService {

  product$: ReplaySubject<Product> = new ReplaySubject<Product>(1);

  set product(value: Product) {
    this.product$.next(value);
  }

  public isProductUnavailable$ = combineLatest([this.categoriesMenu$, this.product$])
    .pipe(
      filter(([categoriesMenu, currentProduct]) => {
        return !!categoriesMenu && !!currentProduct;
      }),
      map(([categoriesMenu, currentProduct]) => {
        let breadcrumbs: CategoryMenuItem[] = [];
        currentProduct.categories?.forEach(category => {
          if (category?.id) {
            const categoryBreadcrumbs: CategoryMenuItem[] | null = categoriesMenu.map[category.id]?.breadcrumbs;
            if (categoryBreadcrumbs) {
              breadcrumbs = [...breadcrumbs, ...categoryBreadcrumbs].filter(b => !!b);
            }
          } else {
            console.error('no category category', category);
            console.error('no category currentProduct', currentProduct);
          }
        });

        const isProductUnavailable: boolean = breadcrumbs
            .filter(breadcrumb => breadcrumb.source.unavailable === true).length > 0
          || currentProduct.unavailable === true;
        return isProductUnavailable;
      }),
      shareReplay(1)
    );

  description: string;
  snipcartImageUrl: string;
  productUnvailable: boolean;

  constructor(
    @Inject(CATEGORIES_MENU) public categoriesMenu$: Observable<CategoryMenu>
  ) {
  }

}
